import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { GoogleMap, GoogleMapStyle } from '@lib/geo/google/map';
import { BASE_COLORS } from '@lib/ui/theme';

declare let nite: any;

@Injectable({
  providedIn: 'root',
})
export class MapNiteLayerService {
  public inited: boolean = false;

  private _map: GoogleMap;
  private readonly _destroy$ = new Subject<void>();

  constructor() {}

  public onMapLoaded(googleMap: GoogleMap): void {
    this._map = googleMap;

    this._map
      .on('styleChange')
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        if (this.inited) {
          const fillColor = this._getFillColor(this._map.getStyle());
          nite.init(this._map.mapInstance, fillColor);
        }
      });
  }

  public addToMap(): void {
    if (!this._map) {
      return;
    }
    const fillColor = this._getFillColor(this._map.getStyle());
    nite.init(this._map.mapInstance, fillColor);
    this.inited = true;
  }

  public removeFromMap(): void {
    nite.setMap(null);
    this.inited = false;
  }

  private _getFillColor(mapStyle: GoogleMapStyle): string {
    switch (mapStyle) {
      case 'dark':
        return BASE_COLORS['primary-400'];
      default:
        return '#000';
    }
  }
}
